<template>
    <div>
        <b-card class="sa-card" header="Data Evento" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ this.getLabelTraduora("patient.cardiology.lblEventDate") }}</label>
                    <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataEvento" type="datetime" disabled></date-picker>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Diagnosi" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Categoria</label>
                    <span class="sa-data">{{ jsonData.categoriaDiagnosi }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Diagnosi</label>
                    <span class="sa-data">{{ jsonData.diagnosi }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Altro</label>
                    <p v-html="jsonData.diagnosiAltro"></p>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Trattamento" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Trattamento</label>
                    <span class="sa-data">{{ jsonData.prestazione }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Prezzo</label>
                    <span class="sa-data">{{ jsonData.prezzoPrestazione }}</span>
                </b-col>
            </b-row>
        </b-card>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card" header="Refertazione" header-tag="header" footer-tag="footer" title="" :disabled="isDisalble">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <p v-html="jsonData.note"></p>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import UtilityMixin from "../../../../../utility/UtilityMixin";
export default {
    components: { DatePicker },
    mixins: [UtilityMixin],

    props: {
        idEvento: {
            type: String,
            default: function () {
                return null;
            },
        },
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
        // jsonData: {
        //     type: Object,
        //     default: function () {
        //         return {
        //             conclusioni: "",
        //             dataEvento: new Date().getTime(),
        //         };
        //     },
        // },
    },
    mounted() {
        let me = this;
        if (me.idEvento !== null) {
            me.id = me.idEvento;
        } else {
            me.id = this.$route.params.id;
        }
        // me.jsonData.dataEvento = new Date().getTime();
        me.loadData();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        // currentPage() {
        //     let me = this;
        //     me.loadDatiPacs();
        // },
    },
    data() {
        return {
            rows: 0,
            currentPage: 1,
            perPage: 10,
            pathResource: "/visitabotox",
            isDisalble: false,
            linkPacs: "",
            id: "-1",
            jsonData: {},
            idRisorsa: null,
            disableCampi: false,
            listaRichieste: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Data Ora",
                    key: "dataOraResponse",
                    formatter: function (value) {
                        return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
                    },
                },
                { class: "sa-table-column-action-single", key: "actions", label: "", thStyle: "width: 8rem" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            console.log("PD");

            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            axios.get(link).then((response) => {
                me.jsonData = response.data.data;
                // me.loadDatiPacs();
                me.showModalLoading = false;
            });
        },

        onUpdateBase64() {},
        onUpdateLista(data) {
            let me = this;
            me.listaRichieste = data;
            if (me.listaRichieste.length > 0) {
                me.disableCampi = true;
                if (me.listaRichieste[0].statoAttuale !== "IN VISITA") {
                    me.disableCampi = false;
                }
            }
        },
        onVisualizza(id) {
            let me = this;
            me.isDisalble = false;
            let link = process.env.VUE_APP_PATH_API + me.pathPacsEndpoint + id;
            axios.get(link).then((response) => {
                me.linkPacs = "";
                me.linkPacs = response.data.data.url;
                console.log(me.linkPacs);
            });
        },
        onClose() {
            let me = this;
            me.linkPacs = "";
        },
    },
};
</script>

<style></style>
